/* eslint-disable */
import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import WebhookDataBody from "components/WebhookComponents/WebhookDataBody/WebhookDataBody";

const WebhookData = () => {
  useEffect(() => {
    document.title = "Webhook Data";
  }, []);

  return (
    <main id="app">
      <Header moduleName="webhook" />
      <WebhookDataBody />
    </main>
  );
};

export default WebhookData;
